<template>
   <b-card style="margin-bottom: 2rem">
      <div class="d-flex align-items-center justify-content-between">
         <h2 class="mb-0">Employee Time</h2>

         <div class="d-flex align-items-center">
            <b-button
               id="btn-employees-time"
               variant="primary"
               :to="{name: 'employees-table-staff', params: {id: $companyId}}"
            >
               View
            </b-button>
         </div>
      </div>
   </b-card>
</template>

<script>
export default {};
</script>
